import "core-js/modules/es.array.concat.js";
import Cookies from 'js-cookie';
import env from '@/env';
/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} setting cookie setting
 */

export function set() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var cookieSetting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var currentCookieSetting = {
    expires: 1
  };
  Object.assign(currentCookieSetting, cookieSetting);
  Cookies.set("d2admin-".concat(env.VUE_APP_VERSION, "-").concat(name), value, currentCookieSetting);
}
/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */

export function get() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  return Cookies.get("d2admin-".concat(env.VUE_APP_VERSION, "-").concat(name));
}
/**
 * @description 拿到 cookie 全部的值
 */

export function getAll() {
  return Cookies.get();
}
/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */

export function remove() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  return Cookies.remove("d2admin-".concat(env.VUE_APP_VERSION, "-").concat(name));
}